/**
 * @generated SignedSource<<6b5d0bdf663a88d311920b2f2804f16c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ShareBookingInput = {
  bookingId: string;
};
export type useShareBookingMutation$variables = {
  input: ShareBookingInput;
};
export type useShareBookingMutation$data = {
  readonly shareBooking: {
    readonly booking: {
      readonly shareUrl: string | null | undefined;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useShareBookingMutation = {
  response: useShareBookingMutation$data;
  variables: useShareBookingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shareUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useShareBookingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ShareBookingPayload",
        "kind": "LinkedField",
        "name": "shareBooking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useShareBookingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ShareBookingPayload",
        "kind": "LinkedField",
        "name": "shareBooking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "20d79ffd0c26fcadfbebbfe063725eee",
    "id": null,
    "metadata": {},
    "name": "useShareBookingMutation",
    "operationKind": "mutation",
    "text": "mutation useShareBookingMutation(\n  $input: ShareBookingInput!\n) {\n  shareBooking(input: $input) {\n    success\n    booking {\n      __typename\n      shareUrl\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "59158ab7404dbebfe461545335d2cda0";

export default node;
